import { render, staticRenderFns } from "./CheckpointMicrolearningMenu.vue?vue&type=template&id=785a7172&scoped=true"
import script from "./CheckpointMicrolearningMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointMicrolearningMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointMicrolearningMenu.vue?vue&type=style&index=0&id=785a7172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a7172",
  null
  
)

export default component.exports